import { render, staticRenderFns } from "./RelatedProfiles.vue?vue&type=template&id=05d42325&"
import script from "./RelatedProfiles.vue?vue&type=script&lang=js&"
export * from "./RelatedProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports